import AbstractRequestTask from '../../AbstractRequestTask';
import Launcher from '../../../apa/Launcher';
import Utils from '../../../../utils/Utils';
import {AdsUtils} from "../../../../AAF/Ads/Utils";

class MultiPurchaseButtonInfoV2Task extends AbstractRequestTask {
    constructor(groupIds = '', withoutToken = false) {
        super();
        this.group_ids = groupIds;
        this.withoutToken = withoutToken;
        this.isActiveAdsExperience =  AdsUtils.isAdsEnable()
    }

    getHeaders() {
        const params = super.getParams();
        if(params.user_token) {
            return {
                'Authorization': 'Bearer ' + params.user_token
            };
        } else {
            return {};
        }
    }

    getEncType() {
        return 'multipart/form-data';
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        let _url = `${http}${url}/services/payway/paymentservice/v2/multipurchasebuttoninfo?`;
        _url += Utils.buildQueryParams(this.getGETParams());
        return _url;
    }

    getMethod() {
        return 'POST';
    }

    getParams() {
        const params = {};
        params.extra_params = JSON.stringify({group_ids: this.group_ids});
        return params;
    }

    getShowErrorModal() {
        return false;
    }

    getGETParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.user_token;

        if(this.isActiveAdsExperience) {
          delete params.device_name;
          delete params.device_so;
          delete params.format
        }
        return params;
    }

    getRetriesNumber() {
        return 0;
    }

    success(data, b) {
        this.resolve(data);
    }

    isValid(data) {
        if(data.errors || !data.response || !data.response.listButtons) {
            return false;
        }
        return true;
    }

}

export default MultiPurchaseButtonInfoV2Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/v2/MultiPurchaseButtonInfoV2Task.js